export default __webpack_public_path__ + "static/media/airport.1901a514.jpeg";